<div class="dialog-heading">
  <h5>An error has occurred</h5>
  <span style="flex: 1 1 auto"></span>
</div>

<div>
  <div class="description" *ngIf="data">
    {{ data }}
    <p>
      <a (click)="dialogRef.close()" [routerLink]="['/renewals']">Return to renewals list</a>
    </p>
  </div>

  <div class="dialog-actions">
    <span style="flex: 1 1 auto"></span>
    <button class="close-button" mat-flat-button color="accent" type="button" (click)="dialogRef.close()">Close</button>
  </div>
</div>
